export default __webpack_public_path__ + "static/media/assiny.alt.4c9ff572.png";